<template>
  <div>
    <RexModalV3
      size="md"
      :show="true"
      :title="title"
      @onClose="$emit('onClose')"
      closeButtonVariant="secondary"
    >
      <template #body>
        <div class="k8m-pods-details-modal-body-container">
          <div class="k8m-pods-details-modal-body-item">
            <RexModalLabel :primaryLabel="exitCode + ':'" />
            <RexInfoLabel :info="code" />
          </div>
          <div class="k8m-pods-details-modal-body-item">
            <RexModalLabel :primaryLabel="message + ':'" />
            <RexInfoLabel :info="messageDetails" />
          </div>
        </div>
      </template>
    </RexModalV3>
  </div>
</template>
<script>
import RexModalV3 from '@/rex-components/RexModalV3.vue';
import RexModalLabel from '@/rex-components/rex-modal-label.vue';
import RexInfoLabel from '@/rex-components/rex-info-label.vue';

export default {
  components: {
    RexModalV3,
    RexModalLabel,
    RexInfoLabel,
  },
  props: {
    initValues: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      title: this.initValues.title || '',
      reason: this.initValues.reason || '',
      exitCode: this.initValues.exitCode || '',
      message: this.initValues.message || '',
      code: this.initValues.code || '',
      messageDetails: this.initValues.messageDetails || '',
    };
  },
};
</script>

<style lang="scss" scoped>
.k8m-pods-details-modal-body-container {
  margin: 1rem 0rem;
}

.k8m-pods-details-modal-body-item {
  margin-bottom: 2.25rem;
}

.k8m-pods-details-modal-title-content {
  color: $font-primary;
}
</style>
